export default __webpack_public_path__ + "static/media/buck_converter.0f6a7d87.svg";